import { Component }                 from '@angular/core';
import {
	ErsPresetEnum,
	ErsVariant
}                                    from '@app/modules/ers/models/ers.model';
import { ErsService }                from '@app/modules/ers/services/ers.service';
import {
	IBaseHttpParams,
	RequestCompleteListState
}                                    from '@core/interfaces/api.interface';
import { SelectFilterBaseComponent } from '@shared/list-operations/components/select-filters/select-filter-base/select-filter-base.component';
import { ISelectFilterable }         from '@shared/list-operations/model/filter.model';
import { Observable }                from 'rxjs';

@Component( {
	selector: 'app-select-filter-ers',
	templateUrl: './../select-filter-base/select-filter-base.component.html'
} )
export class SelectFilterErsComponent extends SelectFilterBaseComponent implements ISelectFilterable {

	constructor(
		private readonly ersService: ErsService
	) {
		super();
	}

	searchRequestCallback = ( searchRequestParams: IBaseHttpParams ): Observable<RequestCompleteListState<ErsVariant>> => {

		/*
		 * Todo ELSTER/ListOps refactoring
		 *  currently, `presetId` has to be an optional property in the filter
		 *  config, because not all entities support Presets. This property being
		 *  optional, however, may lead to failure of the XHR for the ERS list,
		 *  because it requires a Preset ID to be present in the search filter data,
		 *  for calling the correct API endpoint (internal ERS vs external ERS)
		 */
		const presetId: ErsPresetEnum = this.defaultFilterData?.selectFilter?.presetId as ErsPresetEnum;

		return this.ersService.search(
			{
				caller: 'SelectFilterErsComponent:searchRequestCallback',
				params: searchRequestParams,
				presetId,
				storeConfig: { updateStore: false }
			}
		);
	};
}
